import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Menu, X } from 'lucide-react';

const links = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About Us' },
  { id: 'categories', label: 'Categories' },
  { id: 'legacy', label: 'Legacy' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'contact', label: 'Contact' },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Change navbar style on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setMobileMenuOpen(false);
  };

  // MOBILE MENU: render in a portal so it’s always above all pages,
  // but use your OLD classes: nav-menu + mobile-open (so old bg + animation return)
  const mobileMenu = mobileMenuOpen
    ? createPortal(
        <>
          {/* Dark backdrop */}
          <div
            className="mobile-menu-backdrop"
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 9998,
            }}
            onClick={() => setMobileMenuOpen(false)}
            aria-hidden="true"
          />

          {/* Mobile menu overlay – right side, uses your .nav-menu.mobile-open CSS */}
          <ul
            className="nav-menu mobile-open"
            style={{
              position: 'fixed',
              top: 0,
              right: 0,        // PANEL ON THIS SIDE
              bottom: 0,
              zIndex: 9999,
            }}
          >
            {links.map((link) => (
              <li key={link.id}>
                <button onClick={() => scrollToSection(link.id)}>
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </>,
        document.body
      )
    : null;

  return (
    <>
      <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="nav-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_e20de504-1631-4d11-a1e2-88bb70ca8e11/artifacts/b1v0md0r_logogogo.png"
              alt="JB MARBLE"
            />
          </div>

          {/* Desktop nav (your existing styling will apply here) */}
          <ul className="nav-menu">
            {links.map((link) => (
              <li key={link.id}>
                <button onClick={() => scrollToSection(link.id)}>
                  {link.label}
                </button>
              </li>
            ))}
          </ul>

          {/* Mobile toggle button */}
          <button
            className="mobile-menu-toggle"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMobileMenuOpen((prev) => !prev);
            }}
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
            type="button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {mobileMenu}
    </>
  );
};

export default Navigation;